<template>
    <i class="link fa fa-edit" @click="triggerEditAbsence()"></i>
</template>

<script>
import axios from "axios";

export default {
    setup() {
    },
    name: "EditAbsenceButton",
    created() {
    },
    props: {
        absence_id: String,
    },
    data() {
        return {
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        triggerEditAbsence() {
            console.log('emit id ', this.absence_id);
            this.emitter.emit('edit-absence', {'id': parseInt(this.absence_id)});
        }
    }
};
</script>

<style scoped></style>
